import type { Floorplan } from '@vibesites/schema';
import { parseBedCount } from './bedroomFormatting';

/** `0` = studio, `1`–`5` = bedroom count, `'townhome'` = name/code/description match. */
export type PlanType = 0 | 1 | 2 | 3 | 4 | 5 | 'townhome';

const TOWNHOME_PATTERN = /town\s*-?\s*(home|house)s?|\bTH\b/i;

function isTownhome(plan: Floorplan): boolean {
  return [plan.floorplan_name, plan.floorplan_code, plan.floorplan_description].some(
    (v) => typeof v === 'string' && TOWNHOME_PATTERN.test(v),
  );
}

export function matchesPlanType(plan: Floorplan, planType: PlanType): boolean {
  if (plan.floorplan_is_disabled) return false;
  if (planType === 'townhome') return isTownhome(plan);
  return parseBedCount(plan.floorplan_beds_min) === planType;
}
